import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import PropTypes from "prop-types";

/**
 * Wrapper for MUI CircularProgress component to set the color to the
 * --siteconfig-ui-btn-stdcolor-rgba css variable
 *
 * @param {Number} props.size size of the spinner
 * @param {Object} props.style other styles to pass to CircularProgress
 *
 * @returns {JSX.Element}
 */
const LoadingSpinner = (props) => {
    return (
        <CircularProgress
            size={props.size ?? 40}
            sx={{
                color: 'var(--siteconfig-ui-btn-stdcolor-rgba)',
                ...props.style
            }}
        />
    )
}

LoadingSpinner.propTypes = {
    style: PropTypes.object,
    size: PropTypes.number,
}

LoadingSpinner.defaultProps = {
    style: {},
    size: 40,
}

export default LoadingSpinner;
